import * as React from "react";

export const DashboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.42857 1.92857C6.42857 0.863839 7.29241 0 8.35714 0H9.64286C10.7076 0 11.5714 0.863839 11.5714 1.92857V16.0714C11.5714 17.1362 10.7076 18 9.64286 18H8.35714C7.29241 18 6.42857 17.1362 6.42857 16.0714V1.92857ZM0 9.64286C0 8.57812 0.863839 7.71429 1.92857 7.71429H3.21429C4.27902 7.71429 5.14286 8.57812 5.14286 9.64286V16.0714C5.14286 17.1362 4.27902 18 3.21429 18H1.92857C0.863839 18 0 17.1362 0 16.0714V9.64286ZM14.7857 2.57143H16.0714C17.1362 2.57143 18 3.43527 18 4.5V16.0714C18 17.1362 17.1362 18 16.0714 18H14.7857C13.721 18 12.8571 17.1362 12.8571 16.0714V4.5C12.8571 3.43527 13.721 2.57143 14.7857 2.57143Z"
      fill="currentColor"
    />
  </svg>
);
